import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Modal, Form } from "react-bootstrap";
import { ButtonComponent, AnchorComponent } from "../elements";
import axios from "axios";
import Select from 'react-select';
import { encode } from 'base-64';
import { API_URL, APP_PREFIX_PATH, getApiMessage } from "../../constant/constant";
import PaginationComponent from "../PaginationComponent";
import { Row, Col } from "react-bootstrap";
import LabelFieldComponent from "../fields/LabelFieldComponent";
import { Link } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import categoryImage from '../../assets/img/category.webp';


export default function ManageConsultationTablePayment({ thead, tbody }) {
    const { t, currentLanguage } = useContext(TranslatorContext);
    const langCode = currentLanguage?.code || "en";
    const [Payment, setPayment] = useState([]);



    const [Error, setError] = useState('');
    const [DeleteId, setDeleteId] = useState('');

    const [userData, setUserData] = useState("");
    const [editModal, setEditModal] = useState(false);
    const [AddModal, setAddModal] = useState(false);
    const [alertModal, setAlertModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);


    const [AddService, setAddService] = useState('');
    const [addImage, setaddImage] = useState('');
    const [EditService, setEditService] = useState('');
    const [EditImage, setEditImage] = useState('');
    const [EditId, setEditId] = useState('');

    const [AddServiceError, setAddServiceError] = useState('');
    const [addImageError, setaddImageError] = useState('');
    const [EditServiceError, setEditServiceError] = useState('');
    const [EditImageError, setEditImageError] = useState('');
    const [saveEditLoading, setSaveEditLoading] = useState(false);
    const [addServiceLoading, setAddServiceLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);

    const [searchTerm, setSearchTerm] = useState("");
    const entriesPerPage = 5;

    const indexOfLastEntry = currentPage * entriesPerPage;
    const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;


    const filteredUsers = Payment.filter((user) => {
        const lowercasedTerm = searchTerm.toLowerCase();
        return (
            user.user_name?.toLowerCase().includes(lowercasedTerm) ||
            user.clinic_name?.toLowerCase().includes(lowercasedTerm) ||
            user.doctor_name?.toLowerCase().includes(lowercasedTerm) ||
            (user.payment !== undefined && user.payment !== null &&
                (String(user.payment).replace(/,/g, '').includes(lowercasedTerm) ||
                    lowercasedTerm === String(user.payment) ||
                    lowercasedTerm === String(user.payment).replace(/,/g, '')
                )) ||
            user.createtime?.toLowerCase().includes(lowercasedTerm)
        );
    });


    const currentUsers = filteredUsers.slice(indexOfFirstEntry, indexOfLastEntry);

    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

    const fetchServiceDetails = () => {


        axios.get(API_URL + "/get_consultation_payment")
            .then((response) => {
                setPayment(response.data.consultaionPayment_arr || [])
                // setServiceDetails(response.data.service_arr.reverse() || []);
                console.log(response.data.consultaionPayment_arr);
            })
            .catch((error) => {
                console.error('Error fetching user details:', error);
            });
    };




    function formatCurrency(amount) {
        return new Intl.NumberFormat('en-US', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount);
    }





    useEffect(() => {
        fetchServiceDetails();
    }, []);

    const handleUserAction = (action, service_id, experience_qualification) => {

        if (action === 'edit') {
            setEditId(service_id);
            setEditService(experience_qualification);

        }
        else if (action === 'delete') {
            setAlertModal(true);
            setDeleteId(service_id);
        }
    }

    const DoctorDelete = () => {
        setError("");
        setDeleteLoading(true);
        axios.post(API_URL + '/delete_service', { service_id: DeleteId })
            .then((res) => {
                if (!res.data.success) {
                    setError(getApiMessage(res.data, langCode) || t("something_went_wrong"));
                    return;
                }
                setAlertModal(false);
                fetchServiceDetails();
            })
            .catch((error) => {
                setError(getApiMessage(error.response?.data, langCode) || error.message || t("something_went_wrong"));
                console.error(error);
            })
            .finally(() => setDeleteLoading(false));
    }

    const handleEditService = () => {

        let hasError = false;
        if (!EditService || EditService.trim() == '') {
            setEditServiceError('Please enter service name');
            hasError = true;
        }




        if (hasError) {
            return;
        }




        const formData = new FormData();
        formData.append('service_id', EditId);
        formData.append('service_name', EditService);
        formData.append('service_image', EditImage);

        setError("");
        setSaveEditLoading(true);
        axios.post(API_URL + '/edit_service', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }).then(response => {
            if (!response.data.success) {
                setError(getApiMessage(response.data, langCode) || t('service_already_exist'));
                return;
            }
            setEditModal(false);
            fetchServiceDetails();
        })
            .catch(error => {
                setError(getApiMessage(error.response?.data, langCode) || error.message || t("something_went_wrong"));
                console.error('Error updating service:', error);
            })
            .finally(() => setSaveEditLoading(false));
    };

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };


    // add doctor 
    const handleAddService = () => {

        let hasError = false;
        if (!AddService || AddService.trim() == '') {
            setAddServiceError('Please enter service name');
            hasError = true;
        }

        if (!addImage) {
            setaddImageError('Please upload image')
            hasError = true;
        }


        if (hasError) {
            return;
        }

        const formData = new FormData();
        formData.append('service_name', AddService);

        formData.append('service_image', addImage);

        setError("");
        setAddServiceLoading(true);
        axios.post(API_URL + '/add_service', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }).then(response => {
            if (!response.data.success) {
                setError(getApiMessage(response.data, langCode) || t('service_already_exist'));
                return;
            }
            setAddModal(false);
            fetchServiceDetails();
        })
            .catch(error => {
                setError(getApiMessage(error.response?.data, langCode) || error.message || t("something_went_wrong"));
                console.error('Error adding service:', error);
            })
            .finally(() => setAddServiceLoading(false));
    };

    return (
        <>

            <Row xs={1} sm={2} xl={4} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Col>
                    <LabelFieldComponent
                        type="search"
                        // label={t('search_by')}
                          icon="Search"
                        placeholder={`${t('search_here')}`}
                        labelDir="label-col"
                        fieldSize="mb-4 w-100 h-md"
                        value={searchTerm}
                        onChange={handleSearch}
                    />
                </Col>

            </Row>




            <div className="mc-table-responsive">
                <table className="mc-table">
                    <thead className="mc-table-head primary">
                        <tr>
                            <th>
                                <div className="mc-table-check">
                                    <p>{t("sno")}</p>
                                </div>
                            </th>
                            <th>{t("user_name")}</th>
                            <th>{t("clinic_name")}</th>
                            <th>{t("doctor_name")}</th>
                            <th>{t("payment")}</th>
                            <th>{t("commission")} (%)</th>
                            <th>{t("commission")} (KWD)</th>
                            <th>{t("clinic_payment")} (KWD)</th>

                            <th>{t("transaction")}</th>
                        </tr>
                    </thead>
                    <tbody className="mc-table-body even">
                        {currentUsers && currentUsers.length > 0 ? (
                            currentUsers?.map((item, index) => (
                                <tr key={index}>
                                    <td title="id">
                                        <div className="mc-table-check">
                                            <p>{indexOfFirstEntry + index + 1}</p>
                                        </div>
                                    </td>

                                    {/* <td title={item.service_name}>
                                    <div className="mc-table-profile">
                                        <img
                                            src={item.service_image ? `${item.
                                                service_image}` : `doctor_placeholder.webp`}
                                            alt="Profile"
                                            style={{ width: '50px', height: '50px', borderRadius: '50%', objectFit: 'cover' }}
                                        />
                                    </div>
                                </td> */}
                                    <td>{item.user_name || 'NA'}</td>
                                    <td>
                                        <span>{item.clinic_name || 'NA'}</span>
                                    </td>
                                    <td>{item.assigned_doctor_name || item.doctor_name || 'NA'}</td>
                                    <td>{formatCurrency(item.payment) || 'NA'}</td>
                                    <td>{item.downpayment_percentage || 'NA'} %</td>
                                    <td>{formatCurrency((item.payment * item.downpayment_percentage) / 100)}</td>
                                    <td>{formatCurrency((item.payment) - (item.payment * item.downpayment_percentage) / 100)}</td>


                                    <td>{item.createtime || 'NA'}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="8" style={{ textAlign: 'center' }}>
                                    {t("no_data_available")}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>


                <PaginationComponent
                    totalEntries={filteredUsers.length}
                    entriesPerPage={entriesPerPage}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                />

                <Modal show={editModal} onHide={() => setEditModal(false)}>
                    <div className="mc-user-modal">
                        <img
                            src={categoryImage}
                            alt="Profile"
                        />
                        <h4>{userData?.name}</h4>
                        <p>{userData?.email}</p>
                        <Form.Group className="form-group mb-4 ml-2">
                            <Form.Label>{t('service_name')}</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder={t('enter_service_name')}
                                value={EditService}
                                onChange={(e) => { setEditService(e.target.value); setEditServiceError(''); setError('') }}
                            />
                            <p style={{ color: 'red' }}>{EditServiceError}</p>
                        </Form.Group>
                        <Form.Group className="form-group mb-4 ml-2">
                            <Form.Label>{t('image')}</Form.Label>
                            <Form.Control
                                type="file"
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    setEditImage(file);
                                    setEditImageError('')
                                }}
                            />
                            <p style={{ color: 'red' }}>{EditImageError}</p>
                        </Form.Group>

                        <p style={{ color: 'red' }}>{Error}</p>
                        <Modal.Footer>
                            <ButtonComponent type="button" className="btn btn-secondary" onClick={() => { setEditModal(false); setEditService(''); setEditServiceError(''); setEditImageError(''); setError('') }}>
                                {t('close_popup')}
                            </ButtonComponent>
                            <ButtonComponent type="button" className="btn btn-success" onClick={handleEditService} disabled={saveEditLoading}>
                                {saveEditLoading ? (t('loading') || 'Loading...') : t('save_changes')}
                            </ButtonComponent>
                        </Modal.Footer>
                    </div>
                </Modal >

                <Modal show={AddModal} onHide={() => setAddModal(false)}>
                    <div className="mc-user-modal">
                        <img
                            src={categoryImage}
                            alt="Profile"
                        />
                        <h4>{userData?.name}</h4>
                        <p>{userData?.email}</p>
                        <Form.Group className="form-group mb-4 ml-2">
                            <Form.Label>{t('service_name')}</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder={t('enter_service_name')}
                                value={AddService}
                                onChange={(e) => { setAddService(e.target.value); setAddServiceError(''); setError('') }}
                            />
                            <p style={{ color: 'red' }}>{AddServiceError}</p>
                        </Form.Group>
                        <Form.Group className="form-group mb-4 ml-2">
                            <Form.Label>{t('image')}</Form.Label>
                            <Form.Control
                                type="file"
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    setaddImage(file);
                                    setaddImageError('')
                                }}
                            />
                            <p style={{ color: 'red' }}>{addImageError}</p>
                        </Form.Group>
                        <p style={{ color: 'red' }}>{Error}</p>

                        <Modal.Footer>
                            <ButtonComponent type="button" className="btn btn-secondary" onClick={() => { setAddModal(false); setAddService(''); setaddImageError(''); setAddServiceError(''); setError('') }}>
                                {t('close_popup')}
                            </ButtonComponent>
                            <ButtonComponent type="button" className="btn btn-success" onClick={handleAddService} disabled={addServiceLoading}>
                                {addServiceLoading ? (t('loading') || 'Loading...') : t('save_changes')}
                            </ButtonComponent>
                        </Modal.Footer>
                    </div>
                </Modal >

                <Modal show={alertModal} onHide={() => !deleteLoading && setAlertModal(false)}>
                    <div className="mc-alert-modal">
                        <i className="material-icons">new_releases</i>
                        <h3>are your sure!</h3>
                        <p>Want to delete this service?</p>
                        {Error && <p style={{ color: 'red', marginTop: '8px' }}>{Error}</p>}
                        <Modal.Footer>
                            <ButtonComponent type="button" className="btn btn-secondary" onClick={() => setAlertModal(false)}>{t('close')}</ButtonComponent>
                            <ButtonComponent type="button" className="btn btn-danger" onClick={() => DoctorDelete()} disabled={deleteLoading}>
                                {deleteLoading ? (t('loading') || 'Loading...') : t('delete')}
                            </ButtonComponent>
                        </Modal.Footer>
                    </div>
                </Modal >
            </div >
        </>
    );
}
